import "./index.0.css";
import Draggable from 'vuedraggable';
import IfSwitchBranchEditor from "./ifSwitchBranchEditor";
import { EventPanelIcons } from "../../../../lib/comps/PropPanel/EventPanelNew/eventPanelIcons";
import { cloneDeep, isEqual } from "lodash-es";
const __script_base__ = {
  name: 'IfSwitchBranchList',
  components: {
    Draggable,
    IfSwitchBranchEditor
  },
  data() {
    return {
      internalValue: [],
      deleteIcon: EventPanelIcons.deleteIcon
    };
  },
  created() {
    // 保持内部引用 防止重渲染导致内部的simple-flow-step-editor折叠
    this.$watch('value', val => {
      if (!isEqual(val, this.internalValue)) {
        this.internalValue.length = 0;
        this.internalValue.push(...val);
      }
    }, {
      immediate: true
    });
    this.$watch('internalValue', val => {
      if (!isEqual(val, this.value)) {
        this.$emit('change', val);
      }
    }, {
      deep: true
    });
  },
  props: {
    value: Array
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  methods: {
    addBranch() {
      // eslint-disable-next-line vue/no-mutating-props
      this.internalValue.push({
        condition: '',
        expanded: true,
        disabled: false,
        steps: [],
        key: Math.random().toString(36).substr(2)
      });
    },
    deleteBranch(index) {
      // eslint-disable-next-line vue/no-mutating-props
      this.internalValue.splice(index, 1);
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("draggable", {
    staticClass: "ucd-sfeList ucd-IfSwitchBranchList",
    attrs: {
      list: _vm.internalValue,
      draggable: ".ucd-IfSwitchBranchList-branch",
      animation: 300,
      handle: ".ucd-sfeStep-handle, .ucd-sfeStep-toggle, .ucd-sfeStep-actions"
    }
  }, [_vm._l(_vm.internalValue, function (branch, idx) {
    return _c("IfSwitchBranchEditor", {
      key: branch.key || idx,
      staticClass: "ucd-sfeStep ucd-IfSwitchBranchList-branch",
      attrs: {
        value: branch,
        index: idx
      }
    }, [_c("button", {
      staticClass: "ucd-sfeStep-button",
      attrs: {
        slot: "actions",
        title: "删除分支"
      },
      on: {
        click: function ($event) {
          $event.preventDefault();
          return _vm.deleteBranch(idx);
        }
      },
      slot: "actions"
    }, [_c("img", {
      attrs: {
        src: _vm.deleteIcon
      }
    })])]);
  }), _vm._v(" "), _c("div", {
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [!!_vm.internalValue.length ? _c("div", {
    staticClass: "ucd-sfeList-decoratorLine"
  }) : _vm._e()]), _vm._v(" "), _c("div", {
    class: ["ucd-sfeList-footer", !!_vm.internalValue.length && "footerTab"],
    staticStyle: {
      cursor: "pointer"
    },
    attrs: {
      slot: "footer"
    },
    on: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.addBranch.apply(null, arguments);
      }
    },
    slot: "footer"
  }, [_c("div", {
    staticClass: "ucd-sfeToggle isYellow ucd-sfeList-footer-plusIcon smallToggleIcon"
  }, [_vm._v("\n      ＋\n    ")]), _vm._v(" "), _c("div", {
    staticClass: "ucd-sfeList-footer-textBox ucd-IfSwitchBranchList-addBranch",
    class: {
      isInFilledList: _vm.internalValue && !!_vm.internalValue.length
    }
  }, [_c("div", [_vm._v("\n        添加条件分支\n      ")]), _vm._v(" "), !_vm.internalValue.length ? _c("div", {
    staticClass: "ucd-IfSwitchBranchList-addBranch-addAtLast"
  }) : _vm._e()])])], 2);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/designerComponents/IfSwitchBranchList/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);